import { gql } from '@apollo/client/core';

export const CREATE_TIMETABLE_TEMPLATE = gql`
  mutation CreateTimetableTemplate($input: CreateTimetableTemplateInput!) {
    createTimetableTemplate(input: $input) {
      id
      name
    }
  }
`;

export const CREATE_TIMETABLE_TIME_SLOT = gql`
  mutation CreateTimetableTimeSlot($input: CreateTimetableTimeSlotInput!) {
    createTimetableTimeSlot(input: $input) {
      id
      name
      start_time
      end_time
      type
      color
    }
  }
`;

export const CREATE_TIMETABLE = gql`
  mutation CreateTimetable($input: CreateTimetableInput!) {
    createTimetable(input: $input) {
      id
      title
    }
  }
`;

export const UPSERT_TIMETABLE_ENTRY = gql`
  mutation UpsertTimetableEntry($input: UpsertTimetableEntryInput!) {
    upsertTimetableEntry(input: $input) {
      id
      day_of_week
      teachable {
        __typename
        ... on Subject { id name }
        ... on Course { id course_code course_title }
      }
      staff {
        id
        user {
          name
        }
      }
    }
  }
`;

export const UPDATE_TIMETABLE_TEMPLATE = gql`
  mutation UpdateTimetableTemplate($input: UpdateTimetableTemplateInput!) {
      updateTimetableTemplate(input: $input) {
          id
          name
      }
  }
`;

export const DELETE_TIMETABLE_TEMPLATE = gql`
    mutation DeleteTimetableTemplate($id: ID!) {
        deleteTimetableTemplate(id: $id) {
            id
        }
    }
`;

export const DELETE_TIMETABLE_ENTRY = gql`
    mutation DeleteTimetableEntry($id: ID!) {
        deleteTimetableEntry(id: $id) {
            id
        }
    }
`;

export const DELETE_TIMETABLE_TIME_SLOT = gql`
    mutation DeleteTimetableTimeSlot($id: ID!) {
        deleteTimetableTimeSlot(id: $id) {
            id
        }
    }
`;

export const UPDATE_TIMETABLE_TIME_SLOT = gql`
    mutation UpdateTimetableTimeSlot($id: ID!, $input: UpdateTimetableTimeSlotInput!) {
        updateTimetableTimeSlot(id: $id, input: $input) {
            id
            name
            start_time
            end_time
            type
            color
        }
    }
`;
